'use strict';

angular.module('far.mountains')
	.controller('MountainsRoutesByRegionController', function(
		$scope,
		$log,
		$http,
		$timeout,
		$document,
		$q,
		pagination,
		form,
		mountainRoutes,
		mountainRegions,
		mountainRouteTypes,
		mountainRouteComplexities
	) {
		var vm = {
			hasSubmitted: false,
			pagination: pagination('mountainsRoutes', {next: nextPage,itemsOnPage: 100}),
			totalPages: 0,
			peaksFilter: form('peaksFilter'),
			popularRoutes: [],
            startOffset: 0,
			peaksFilterModel: {
				mountain_area: null,
				mountain_region: null,
				mountain: null
			},
			moreFilterModel: {
				route_types: mountainRouteTypes.list,
				route_complexities: mountainRouteComplexities.list,
				peak_height: {
					min: 0,
					max: 8848,
					options: {
						floor: 0,
						ceil: 8848,
						step: 100
					}
				},
				sortBy: false
			},
			peaksFilterSubmit: peaksFilterSubmit,
			moreFilterSubmit: moreFilterSubmit,
			showFilters: false,
			canShowFilters: false,
			getPeaksStringForRoute: getPeaksStringForRoute,
			getHeightStringForRoute: getHeightStringForRoute,
			getMountainRouteUrl: getMountainRouteUrl,
			getUserProfileUrl: getUserProfileUrl,
			clearFilters: clearFilters,
			getAreaStringForRoute: getAreaStringForRoute,
			getRegionStringForRoute: getRegionStringForRoute,
			addMyAscentUrl: addMyAscentUrl,
			trRouteClass: trRouteClass
		};

		vm.peaksFilter
			.addField('mountainRegion', 'selectObject', {
				validators: {
					required: true
				},
				options: {
					ngChange: changeRegion,
					class: 'form__item form__item_select'
				},
				ngOptions: 'item as item.name for item in field.items track by item.id',
				label: null
			}, mountainRegions.list)
			.addField('mountainArea', 'selectObject', {
				options: {
					ngChange: changeArea,
					class: 'form__item form__item_select'
				},
				ngOptions: 'item as item.name for item in field.items track by item.id',
				label: null
			}, [])
			.addField('mountain', 'selectObject', {
				ngOptions: 'item as (item.name) for item in field.items track by item.id',
				label: null,
				options: {
                    ngChange: function () {
                        $timeout(function() {
                            vm.moreFilterSubmit();
                        });
                    },
					class: 'form__item form__item_select'
				}
			}, []);

		function changeRegion() {
            mountainRegions.setAddBlank(true);

			$timeout(function() {
				//vm.mountain.mountainArea = null;
				if (vm.peaksFilterModel.mountain_region) {
					vm.peaksFilter.$fields.mountain.items = [];

					mountainRegions.list.forEach(function(region) {
						if (region.id == vm.peaksFilterModel.mountain_region.id) {
							vm.peaksFilter.$fields.mountainArea.items = region.mountain_areas;

							$log.debug(vm.peaksFilter.$fields.mountainArea.items);
						}
					});

					vm.peaksFilterSubmit();

                    $document.scrollToElementAnimated(document.getElementById('peaks_filter_form'), 20);
				}
			});
		}

		function changeArea() {
			$timeout(function() {
				//vm.mountain.mountainArea = null;
				if (vm.peaksFilterModel.mountain_area) {
					if ( vm.peaksFilterModel.mountain_area.id == 0 ) {
						vm.peaksFilter.$fields.mountain.items = [];

						return;
					}

					$http.get(Routing.generate('api_entities_get_mountains_by_area', {mountainArea: vm.peaksFilterModel.mountain_area.id}))
						.then(function(response) {
							vm.peaksFilter.$fields.mountain.items = [];
							console.log('mountains_by_area',response.data);

							if ( response.data.length ) {
								vm.peaksFilter.$fields.mountain.items.push({
									id: 0,
									name: '...'
								});

								response.data.forEach(function(mountain) {
									vm.peaksFilter.$fields.mountain.items.push(mountain)
								});

                                vm.moreFilterSubmit();
							}
						})
						.catch(function(response) {
							$log.error(response);
							vm.peaksFilter.$fields.mountain.items = [];
						});

                    //$document.scrollToElementAnimated(document.getElementById('peaks_filter_form'), 20);
				}
			});
		}

		function getFilters() {
			return {
				area_id: vm.peaksFilterModel.mountain_area ? vm.peaksFilterModel.mountain_area.id : null,
				region_id: vm.peaksFilterModel.mountain_region ? vm.peaksFilterModel.mountain_region.id : null,
				mountain_id: vm.peaksFilterModel.mountain ? vm.peaksFilterModel.mountain.id : null,
				route_complexities: vm.moreFilterModel.route_complexities.filter(function(route_complexity) {
					return angular.isDefined(route_complexity.selected) && route_complexity.selected == true;
				}).map(function(route_complexity) {
					return route_complexity.id;
				}),
				route_types: vm.moreFilterModel.route_types.filter(function(route_type) {
					return angular.isDefined(route_type.selected) && route_type.selected == true;
				}).map(function(route_type) {
					return route_type.id;
				}),
				peak_height_min: vm.moreFilterModel.peak_height.min,
				peak_height_max: vm.moreFilterModel.peak_height.max,
                order_by: vm.moreFilterModel.sortBy ? 'ascents_count,desc' : ''
			}
		}
		function clearFilters() {
			vm.moreFilterModel.peak_height.min = 0;
			vm.moreFilterModel.peak_height.max = 8848;
			vm.moreFilterModel.route_complexities.forEach(function(route_complexity) {
				if (angular.isDefined(route_complexity.selected)) {
					delete route_complexity.selected;
				}
			});
			vm.moreFilterModel.route_types.forEach(function(route_type) {
				if (angular.isDefined(route_type.selected)) {
					delete route_type.selected;
				}
			});
		}

		function nextPage(page, count) {
			return $http.get(Routing.generate('api_entities_get_mountainroutes',
				angular.merge({}, getFilters(), {
					offset: vm.startOffset + (page - 1) * count,
					limit: count
				})
			)).then(function(response) {
				var items = [];
				vm.totalPages = Math.ceil(response.headers('X-Total-Count') / count);
				console.log('get_mountainroutes',response.data);
				angular.forEach(response.data, function(item) {
					items.push(item[0]);
				});

				return items;
			}).catch(function(response) {
				$log.error(response);
				return $q.reject(response);
			})
		}

		function peaksFilterSubmit() {
			vm.hasSubmitted = true;
			clearFilters();
			vm.canShowFilters = true;

			vm.pagination.clear();

			// Обновляем список популярных маршрутов
			var popularFilters = {
				area_id: vm.peaksFilterModel.mountain_area ? vm.peaksFilterModel.mountain_area.id : null,
				region_id: vm.peaksFilterModel.mountain_region ? vm.peaksFilterModel.mountain_region.id : null
			};
			getPopularRoutes(popularFilters);
		}

		function moreFilterSubmit() {
			vm.showFilters = false;
			vm.pagination.clear();
		}

		function getPeaksStringForRoute(route) {
			return route.mountain_peaks.map(function(peak) {
				var _return = [];

				if ( peak.name ) {
					_return.push(peak.name);
				}

				return _return.join(', ');
			}).join(' - ');
		}

		function getRegionStringForRoute(route) {
			var _return = [];
			route.mountain_peaks.map(function(peak) {
				_return.push(peak.mountain_region_name);
			});
			return _return[0];
		}

		function getAreaStringForRoute(route) {
			var _return = [];
			route.mountain_peaks.map(function(peak) {
				_return.push(peak.mountain_area_name);
			});
			return _return[0];
		}

		function getHeightStringForRoute(route) {
			var _return = [];
			route.mountain_peaks.map(function(peak) {
				_return.push(peak.height);
			});
			if(_return.length > 1) {
				return '';
			}
			return _return[0];
		}

		function getUserProfileUrl(route) {
			if (route.user) {
				return Routing.generate('user_view', {userId: route.user.id});
			}
		}

		function getMountainRouteUrl(route) {
			return Routing.generate('page_mountainroute_index', {'id': route.id});
		}

		function addMyAscentUrl(route) {
			return Routing.generate('personal_alpbook') + '#/?mountainroute=' + route.id;
		}

		function trRouteClass(status) {
			if(status) {
				return 'page-table__row'
			}
			return 'page-table__row_colored'
		}

		function getPopularRoutes(filters) {
			vm.popularRoutes = [];
			mountainRoutes.getPopular(filters)
				.then(function(routes) {
					angular.forEach(routes, function(route) {
						vm.popularRoutes.push(route[0]);
					});
				});
		}
		getPopularRoutes();

		return vm;
	});
